/**
 * Browser-compatible number utility functions
 * These are simplified versions of the functions from encamp-shared/src/tierii/utilities.ts
 * that don't depend on Node.js-specific packages like encamp-logger
 */

/**
 * Safely parse a string to a float, handling commas and invalid values
 * @param value - The string value to parse
 * @returns The parsed number or null if invalid
 */
export const safeParseFloat = (value: string): number | null => {
  const cleanedValue = value.replace(/,/g, "");
  const parsed = parseFloat(cleanedValue);
  if (isNaN(parsed)) {
    return null;
  }
  return parsed;
};

/**
 * Transform a string to a number, removing commas
 * @param value - The string value to transform
 * @returns The transformed number
 */
export function transformStringToNumber(value: string): number {
  return Number(value.replace(/,/g, ""));
}

/**
 * Transform a string to a number or null, removing commas
 * @param value - The string value to transform (can be null/undefined)
 * @returns The transformed number or null
 */
export function transformStringToNumberOrNull(value: string | null | undefined): number | null {
  return value ? Number(value.replace(/,/g, "")) : null;
}
